var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import classNames from "classnames";
import Transition from "react-transition-group/Transition";
const transitionMapper = {
    entering: "collapsing",
    entered: "collapse show",
    exiting: "collapsing",
    exited: "collapse",
};
function getTransitionClass(status) {
    return transitionMapper[status] || "collapse";
}
const getHeight = (node) => {
    return node.scrollHeight;
};
export const Collapse = (_a) => {
    var { HtmlTag = "div" } = _a, props = __rest(_a, ["HtmlTag"]);
    const [height, setHeight] = useState(null);
    const onEntering = (node, isAppearing) => {
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        setHeight(getHeight(node));
        props.onEntering && props.onEntering(node, isAppearing);
    };
    const onEntered = (node, isAppearing) => {
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        setHeight(null);
        props.onEntered && props.onEntered(node, isAppearing);
    };
    const onExit = (node) => {
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        setHeight(getHeight(node));
        props.onExit && props.onExit(node);
    };
    const onExiting = (node) => {
        // getting this variable triggers a reflow
        // @ts-ignore
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        setHeight(0);
        props.onExiting && props.onExiting(node);
    };
    const onExited = (node) => {
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        setHeight(null);
        props.onExited && props.onExited(node);
    };
    return (React.createElement(Transition, { in: props.isOpen, appear: props.appear, unmountOnExit: props.unmountOnExit, mountOnEnter: props.mountOnEnter, timeout: props.timeout, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }, (status) => {
        let collapseClass = getTransitionClass(status);
        const classes = classNames(props.className, collapseClass, props.navbar && "navbar-collapse");
        const style = height === null ? null : { height };
        let transitionStyle = props.timeout
            ? { transitionDuration: props.timeout + "ms" }
            : null;
        return (React.createElement(HtmlTag, { style: Object.assign(Object.assign({}, style), transitionStyle), className: classes, ref: props.innerRef, "aria-expanded": props.isOpen ? "true" : "false", "data-testid": props.testId }, props.children));
    }));
};
export default Collapse;
//# sourceMappingURL=Collapse.js.map